import { FC, useCallback, useContext, useEffect, useMemo } from 'react';
import { Box, Select } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { VariablesContext } from '../context';
import { useActions, useSelector } from '../../../../hooks';

export const SelectRobotRunId: FC = () => {
  const { endpoint, variables, setVariables } = useContext(VariablesContext);
  const { t } = useTranslation();

  const activityRunsById = useSelector(
    ({ workspaceResources }) => workspaceResources.activityRuns.byId,
  );
  const loadingActivityRuns = useSelector(({ entityStates }) => entityStates.activityRuns.loading);

  const { getActivityRuns } = useActions(({ activityRunActions }) => ({
    getActivityRuns: activityRunActions.getActivityRunsByProcessRun,
  }));

  const robotRunItems = useMemo(
    () =>
      Object.entries(activityRunsById).map(([id, run], index) => {
        return {
          label: `${run.activityName} #${index}`,
          value: id,
        };
      }),

    [activityRunsById],
  );

  useEffect(() => {
    if (variables.processId && variables.processRunId && endpoint.includes('robotRunId')) {
      getActivityRuns(variables.processId, variables.processRunId);
    }
  }, [variables.processId, variables.processRunId]);

  const onChange = useCallback(
    (robotRunId: string) => {
      setVariables({ robotRunId });
    },
    [setVariables],
  );

  let placeholder = robotRunItems.length ? `${t('choose')}...` : t('noRobotRunsForProcess');

  if (loadingActivityRuns) {
    placeholder = t('loading');
  }

  if (!variables.processRunId) {
    placeholder = t('chooseRobotRun');
  }

  return !endpoint.includes('robotRunId') ? null : (
    <Box mb={20}>
      <Select
        label={t('chooseRobotRun')}
        items={robotRunItems}
        value={variables.robotRunId}
        onChange={onChange}
        disabled={loadingActivityRuns || !variables.processRunId}
        placeholder={placeholder}
      />
    </Box>
  );
};
